import { EVENT, TRAITS } from '@/features/dataSources/components/createDataSource/constants';
import { showToast } from '@/features/toasts/toastsSlice';
import { useWorkspace } from '@/features/workspaces/hooks';
import { Select } from '@/lib/Selects';
import { ISelectItem } from '@/models/select';
import { ToastType } from '@/models/toast';
import { TraitDataType, TRAITS_DATA_TYPES, TRAITS_DATA_TYPES_MAP } from '@/models/traits';
import { DEFAULT_DISMISS_DURATION } from '@/providers/ToastProvider';
import { useAppSelector } from '@/reducers';
import { useGetTraitsQuery } from '@/services/endpoints/traits';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

interface ITraitInputProps {
  option: ISelectItem;
  error?: string;
  value?: TraitDataType;
  onChange: (value: TraitDataType) => void;
}

export const DataTypeInput: FC<ITraitInputProps> = ({ value, option, error, onChange }) => {
  const workspace = useWorkspace();
  const { t } = useTranslation('data_types');
  const { t: tAudienceDetails } = useTranslation('audience_details');
  const { data } = useGetTraitsQuery({ workspaceId: workspace.id });
  const dispatch = useDispatch();

  const dataType = (useAppSelector((state) => state.dataSources.edit?.dataSource?.configuration) as { type?: string } | undefined)?.type;

  const traitList: ISelectItem[] = [];

  const dataTypesItems = TRAITS_DATA_TYPES.map((dt) => ({
    id: dt.key,
    label: t(TRAITS_DATA_TYPES_MAP[dt.key as TraitDataType] as any),
  }));

  if (data) {
    const customerTrait = data.customer.map((trait) => ({
      id: trait.id,
      label: trait.displayName,
    }));

    traitList.push(...customerTrait);

    if (dataType === EVENT) {
      const eventTrait = data.event.map((trait) => ({
        id: trait.id,
        label: trait.displayName,
      }));
      traitList.push(...eventTrait);
    }
  }

  useEffect(() => {
    if (option.id === TRAITS.CUSTOM_TRAIT && !value) {
      onChange(dataTypesItems[0].id as TraitDataType);
    }
  }, [option.id, value]);

  switch (option.id) {
    case TRAITS.CUSTOM_TRAIT:
      return (
        <Select
          items={dataTypesItems}
          value={dataTypesItems.find((e) => e.id == value) || dataTypesItems[0]}
          onChange={(e: any) => {
            if (e.id === 'DATE' || e.id === 'DATETIME') {
              dispatch(
                showToast({
                  type: ToastType.WARNING,
                  title: tAudienceDetails('sources_and_rules.date_validation_warning'),
                  dismissDuration: DEFAULT_DISMISS_DURATION * 2,
                })
              );
            }
            onChange(String(e.id) as TraitDataType);
          }}
          error={error}
        />
      );
    case TRAITS.MAP_TO_TRAIT:
    case TRAITS.CONSENT_TRAIT:
    case TRAITS.IGNORE_COLUMN:
    default:
      return <></>;
  }
};
